/**
 * Created by Languagenut on 22/05/2019.
 */

import React  from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import {ProgressBar , Row , Col} from 'react-bootstrap'
import Translation from '../../store/internationalization-store.js';
import Base from '../wizards/assignments/activities_type.js';
import LanguageSelect from '../language_select.js';
import AccountStore from '../../store/account-store.js';
import ProductStore from '../../store/product-store.js';
import ProductService from '../../services/product-service.js';
import Constants from '../../constants.js';

export default class Summary extends Base.component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:"students",
            toggle:false,
            loaded:true,
            additionalList:[]
        };
    }

    componentDidMount(){
        ProductService.getAllAdditionalCurriculums();

        ProductStore.on(Constants.GET_ADDITIONAL_CURRICULUM,  ()=>{
            
            var additionalCurriculums = ProductStore.getAdditionalCurriculums();
        
            var selectedList = [];
            
            for(var i = 0 ; i < additionalCurriculums.length; i++) {
                if (additionalCurriculums[i].isSelected == true) {
                    selectedList.push({uid:"vocabs_additional", data:additionalCurriculums[i].startScreen, 
                        title:"Vocabulary - "+additionalCurriculums[i].name, checked:false, ietf:additionalCurriculums[i].ietf});
                }
            }

            this.setState({
                additionalList:selectedList,
                loaded:true
            })
        });
    }


    goToLink(type, data, title) {
        let screenUID = null;
        window.languagenutAdminTitle = "";
        switch(type)
        {
            case "vocabs":
                screenUID = AccountStore.curriculumData.startScreen;
                if ([9201, 9202, 9203, 20634,20669,20704].indexOf(parseInt(AccountStore.curriculumData.startScreen)) > -1) {
                    window.languagenutAdminTitle = "Cambridge IGCSE";
                } else if ([13300,13301,13302].indexOf(parseInt(AccountStore.curriculumData.startScreen)) > -1) {
                    window.languagenutAdminTitle = "Edexcel-International GCSE Vocabulary";
                }
                break;
            case "custom":
                screenUID = this.customScreen

                break;
            case "vocabs_additional":
                type = 'vocabs';
                screenUID = data;
                window.languagenutAdminTitle = title
                break;
            case "sentences":
                screenUID = AccountStore.curriculumData.sentenceScreen;
                break;
            case "grammar":
                screenUID = AccountStore.curriculumData.grammarScreen;
                break;
            case "verbs":
                screenUID = 0;
                break;
            case "exam":
                screenUID = AccountStore.curriculumData.examScreen;
                break;
            default:
                screenUID = 0;
                break
        }

        if (screenUID == undefined) {
            return "";
        }
        if (this.props.classID == undefined) {
            window.location.hash = "students/reports/"+this.props.studentID+"/report/"+type+'/'+this.language.ietf+'/'+screenUID
        } else {
            window.location.hash = "classes/reports/"+this.props.classID+"/report/"+type+'/'+this.language.ietf+'/'+screenUID
        }
    }
    
    renderlink(cell , row){
        return <a className="hyperlink" onClick={()=>{this.goToLink(row.uid, row.data, row.title)}}>{cell}</a>
    }


    getTasks = function() {
        if (this.language == undefined) {
            return "";
        }
        var data = [];
        var isExam = false;
        var isVocab = false;
        var isCustom = false;
        var isSentence = false;
        var isGrammar = false;
        var isVerb = false;
        for (var i =0; i < this.featuresList.length; i++) {
            if (this.isChecked[features_uid] == undefined) {
                this.isChecked[features_uid] = false;
            }

            console.log(this.featuresList)
            var features_uid = this.featuresList[i].features_uid;

            switch(features_uid) {
                case "vocabs":
                    isVocab = true;
                    break;
                case "custom":
                    isCustom = true;
                    break;
                case "sentences":
                    isSentence = true;
                    break;
                case "grammar":
                    isGrammar = true;
                    break;
                case "verbs":
                    isVerb = true;
                    break;
                case "exam":
                    isExam = true;
                    break;
            } 
        }
        if (isVocab) {
            if ([9201, 9202, 9203, 20634,20669,20704].indexOf(parseInt(AccountStore.curriculumData.startScreen)) > -1) {
                data.push({uid:"vocabs", title:"Vocabulary - Cambridge IGCSE", isExtraVocab:this.state.additionalList.length > 0, checked:this.isChecked[features_uid]});
            } else if ([13300,13301,13302].indexOf(parseInt(AccountStore.curriculumData.startScreen)) > -1) {
                data.push({uid:"vocabs", title:"Vocabulary - Edexcel-International GCSE Vocabulary", 
                    isExtraVocab:this.state.additionalList.length > 0, checked:this.isChecked[features_uid]});
            } else {
                data.push({uid:"vocabs", title:Translation.get(12683 , 'Vocabulary - Vocab By Topic'), 
                    isExtraVocab:this.state.additionalList.length > 0, checked:this.isChecked[features_uid]});
            }
            for (var  i =0; i < this.state.additionalList.length; i++) {
                if (this.language.ietf == this.state.additionalList[i].ietf) {
                    this.state.additionalList[i].isExtraVocab = true;
                    data.push(this.state.additionalList[i]) 
                }
            }
        }

        if (isCustom) {

            if(AccountStore.curriculumData)
            {
                if(AccountStore.curriculumData.customLanguages)
                {
                    if(AccountStore.curriculumData.customLanguages.indexOf(this.language.ietf) >= 0)
                    {
                        data.push({uid:"custom", title:Translation.get(649, "My Content"), checked:this.isChecked[features_uid]});
                    }
                }
            }
        }

        if (isExam) {
            data.push({uid:"exam", title:Translation.get(12042 , 'Exam Skills'), checked:this.isChecked[features_uid]});
        }
        if (isSentence) {
            data.push({uid:"sentences", title:Translation.get(89 , 'Sentence Building'), checked:this.isChecked[features_uid]});
        }
        if (isGrammar) {
            if (AccountStore.curriculumData.grammarScreen != undefined && AccountStore.curriculumData.grammarScreen != null &&
                (this.language.ietf == "de" || this.language.ietf == "fr" || this.language.ietf == "es" || this.language.ietf == "en")) {
                data.push({uid:"grammar", title:Translation.get(100 , 'Grammar'), checked:this.isChecked[features_uid]});
            }
        }
        if (isVerb) {
            var x = AccountStore.curriculumData;
            var y = AccountStore.curriculumData.verbLanguages;
            if (AccountStore.curriculumData.verbLanguages != undefined &&
                AccountStore.curriculumData.verbLanguages.includes(this.language.ietf)) {
                data.push({uid:"verbs", title:Translation.get(1026, 'Verbs'), checked:this.isChecked[features_uid]});
            }
        }

        return data;
    }

    render(){

        const columns = [{
            dataField: 'title',
            text: Translation.get(14 , 'Name'),
            formatter: this.renderlink.bind(this),
        }];

        let options = this.getTasks();
        let buttons =  <BootstrapTable  bordered={ true } keyField='id' data={ options || [] } columns={ columns } />;;



        if(!this.state.loaded || 
            AccountStore.curriculumData.startScreen == undefined) buttons = <ProgressBar animated now={45} animated />

        return <div>
            <Row>
            <Col md={12}><LanguageSelect limitLanguages={this.props.classLanguages} returnValue={this.setLanguageValue.bind(this)} title={<b>{Translation.get(12684 , 'Select a language')}</b>}/></Col>
            </Row>
            <Row>
                <Col md={12}>{buttons}</Col>
            </Row>
        </div>;


    }
}